import React from 'react';
import { LogOut } from 'lucide-react';
import SecondaryActionButton from './SecondaryActionButton';

type LogoutActionButtonProps = React.ComponentProps<typeof SecondaryActionButton>;

const LogoutActionButton: React.FC<LogoutActionButtonProps> = ({ children = 'Logout', ...props }) => (
  <SecondaryActionButton {...props}>
    <LogOut className="h-4 w-4" />
    {children}
  </SecondaryActionButton>
);

export default LogoutActionButton;

